import { BrowserRouter } from 'react-router-dom';
import { LoginSelectors } from 'modules/landingPage/components/login/redux';
import { useAppSelector } from '../modules/hooks/appHooks';
import { LoggedInRoutes } from './LoggedInRoutes';
import { LoggedOutRoutes } from './LoggedOutRoutes';
import { Layout } from '../modules/layout';

export const AppRouter = () => {
  const user = useAppSelector(LoginSelectors.selectUser);
  return (
    <BrowserRouter basename="/eleasing">
      <Layout>{user ? <LoggedInRoutes /> : <LoggedOutRoutes />}</Layout>
    </BrowserRouter>
  );
};
